import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
import { useGeoPrice } from '../lib/pricing';
export function FAQAccordion() {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const {
    pricing,
    formatPrice: fmtPrice
  } = useGeoPrice();
  const faqs = [{
    question: '¿Cómo recibo los planos?',
    answer: <>
          Es una descarga digital. Ingresás tu pago, obtenés{' '}
          <span className="text-white font-bold" data-id="element-85">acceso instantáneo</span> al
          paquete completo. Sin esperas. Pagás una sola vez y listo — sin cargos
          ocultos.
        </>
  }, {
    question: '¿Y si soy completamente nuevo y nunca soldé?',
    answer: <>
          Perfecto. El Bono #4 (Soldar Desde Cero) y el Bono #6 (Herrería Desde
          Cero) te llevan de la mano desde lo más básico.{' '}
          <span className="text-white font-bold" data-id="element-86">Un paso a la vez.</span> Antes
          de que te des cuenta, habrás terminado tu primer proyecto.
        </>
  }, {
    question: '¿Puedo vender lo que fabrique?',
    answer: <>
          ¡Por supuesto! Muchos de nuestros clientes generan ingresos vendiendo
          lo que construyen. El Bono #5 te enseña exactamente{' '}
          <span className="text-white font-bold" data-id="element-87">
            cómo cotizar y cerrar clientes.
          </span>
        </>
  }, {
    question: '¿Por qué tan barato? ¿Cuál es el truco?',
    answer: <>
          No hay truco. Es una{' '}
          <span className="text-[#FF6B00] font-bold" data-id="element-88">
            oferta limitada de lanzamiento.
          </span>{' '}
          Cuando termine, el precio sube a {fmtPrice(pricing.compareAt)}. Para
          los que están aquí ahora: pago único de {fmtPrice(pricing.current)}.
        </>
  }, {
    question: '¿Cuánto tiempo tengo acceso?',
    answer: <>
          Acceso{' '}
          <span className="text-white font-bold uppercase" data-id="element-89">DE POR VIDA.</span>{' '}
          Descargás todo y es tuyo para siempre. Sin fecha de expiración. Sin
          renovaciones.
        </>
  }];
  return <section className="py-8 px-4 bg-[#0d0d0d] relative" data-id="element-90">
      <div className="max-w-3xl mx-auto" data-id="element-91">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-5 text-white" data-id="element-92">
          ¿PREGUNTAS <span className="text-[#FF6B00]" data-id="element-93">FRECUENTES?</span>
        </h2>

        <div className="space-y-3" data-id="element-94">
          {faqs.map((faq, index) => <div key={index} className={`border transition-all duration-300 rounded-lg overflow-hidden ${activeIndex === index ? 'border-[#FF6B00] bg-[#1a1a1a] shadow-[0_0_15px_rgba(255,107,0,0.1)]' : 'border-[#333] bg-[#111] hover:border-[#555]'}`} data-id="element-95">
              <button onClick={() => setActiveIndex(activeIndex === index ? null : index)} className="w-full flex items-center justify-between p-4 text-left focus:outline-none" data-id="element-96">
                <span className={`font-bold text-base md:text-lg ${activeIndex === index ? 'text-[#FF6B00]' : 'text-gray-200'}`} data-id="element-97">
                  {faq.question}
                </span>
                <span className={`ml-4 flex-shrink-0 transition-transform duration-300 ${activeIndex === index ? 'text-[#FF6B00] rotate-180' : 'text-gray-500'}`} data-id="element-98">
                  {activeIndex === index ? <Minus className="w-5 h-5" data-id="element-99" /> : <Plus className="w-5 h-5" data-id="element-100" />}
                </span>
              </button>
              <AnimatePresence data-id="element-101">
                {activeIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} style={{
              overflow: 'hidden',
              contain: 'layout style'
            }} data-id="element-102">
                    <div className="p-5 pt-0 text-gray-400 border-t border-[#333]/50 text-base leading-relaxed" data-id="element-103">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}